import React from 'react'

const PhoneIcon = () => {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_2596_10031)">
<path d="M9.22198 11.045C9.35967 11.1082 9.51478 11.1227 9.66178 11.086C9.80877 11.0492 9.93887 10.9636 10.0307 10.843L10.2673 10.533C10.3915 10.3674 10.5526 10.233 10.7377 10.1404C10.9228 10.0479 11.127 9.99967 11.334 9.99967H13.334C13.6876 9.99967 14.0267 10.1402 14.2768 10.3902C14.5268 10.6402 14.6673 10.9794 14.6673 11.333V13.333C14.6673 13.6866 14.5268 14.0258 14.2768 14.2758C14.0267 14.5259 13.6876 14.6663 13.334 14.6663C10.1514 14.6663 7.09914 13.4021 4.8487 11.1516C2.59827 8.90119 1.33398 5.84894 1.33398 2.66634C1.33398 2.31272 1.47446 1.97358 1.72451 1.72353C1.97456 1.47348 2.3137 1.33301 2.66732 1.33301H4.66732C5.02094 1.33301 5.36008 1.47348 5.61013 1.72353C5.86017 1.97358 6.00065 2.31272 6.00065 2.66634V4.66634C6.00065 4.87333 5.95246 5.07749 5.85989 5.26263C5.76732 5.44777 5.63291 5.60881 5.46732 5.73301L5.15532 5.96701C5.03293 6.06046 4.94666 6.1934 4.91118 6.34324C4.87569 6.49308 4.89317 6.65059 4.96065 6.78901C5.87177 8.63958 7.37027 10.1362 9.22198 11.045Z" stroke="#A3A3A3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_2596_10031">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
  )
}

export default PhoneIcon      